import { vectorhubModules } from '@vectorhub/domain';
/**
 * Resolves the modules visible to the current user.
 *
 * Visible = orgAllowedModules ∩ userModules, filtered to the 4 domain AppModules.
 * One instance per module — no fan-out (D0009). Empty when org has VH not contracted
 * (orgAllowedModules=[]) or the user has no vh_user_access doc (userModules=[]).
 */
export function resolveVectorhubModules(ctx) {
    const visible = new Set(ctx.orgAllowedModules.filter((slug) => ctx.userModules.includes(slug)));
    const modules = vectorhubModules.filter((m) => visible.has(m.slug));
    const instances = modules.map((m) => ({
        id: `${ctx.orgId}:${m.slug}`,
        slug: m.slug,
        parameters: {},
    }));
    return { modules, instances };
}
//# sourceMappingURL=moduleResolver.js.map